// extracted by mini-css-extract-plugin
module.exports = {"layerUpdateDialog":"AddFeatureDialog_layerUpdateDialog__346nP","icon":"AddFeatureDialog_icon__3-KSX","title":"AddFeatureDialog_title__2ECf_"};